export default __webpack_public_path__ + "static/media/passwordsent.d801ae00.svg";